//DESERTLAND.Content.History
import { Utils } from '../cals.utils';
// import { DESERTLAND } from '../desertland.init';
import { App } from '../desertland.app';
import { ROUTES } from '../desertland.router';
// import { TemplateLoader } from '../desertland.templateLoader';
import 'kendo-ui-core';
// import 'kendo-ui-core/js/kendo.layout';
// import 'kendo-ui-core/js/kendo.data';
// import 'kendo-ui-core/js/kendo.mobile.listview';

declare var log, info, warn, groupCollapsed, groupEnd;

export class HistoryContent {
  public page = ROUTES.HISTORY;
  public container = "#tmpl_main_content";
  public tplSel = 'tpl-layout-history';
  public subNavId = '#history_sub_nav';

  public init(params = {}) {
    groupCollapsed("History.init");
    if ($(this.container).length) {
      log("ready for " + this.page);
      this.loadTpl(this.renderTpl);
    } else {
      $(() => {
        log(this.page + " dom ready!");
        if (typeof this.loadTpl === "function" && typeof this.renderTpl === "function") {
          this.loadTpl(this.renderTpl);
        }

      });
    }
    groupEnd("History.init");
  }

  public loadTpl(callback) {
    log(this.page + " > loadTpl");
    if ($(this.tplSel).length) {
      log("// we already have the tpl");
      this.renderTpl({ sel: this.tplSel });
    } else {
      App.templates.loadLayout(this.page, this.tplSel, this.renderTpl);
    }

  }

  public renderTpl = (resp) => {
    $(document).ready(() => {
      log(this.page + " > renderTpl", resp);
      if (resp && resp.sel && $(resp.sel).length) {
        //log($(resp.sel));
        let layout = new kendo.Layout($('#'+resp.tag).html(), { model: App.models.pageView.viewModel });
        $(this.container).empty();
        layout.render($(this.container));
  
        this.loadContent();
  
        this.initEvents();
  
      } else {
        info("no sel?");
      }
    });
  }

  public loadContent() {
    App.content.Learnmore.loadDataTheRenderSubnav(this.subNavId);
  }



  public initEvents() {

    if ($("#history_print").length) {
      $("#history_print").off("click").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        log("history_print click");
      });
    }

    if ($("#history_online").length) {
      $("#history_online").off("click").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        log("history_online click");
      });
    }

  }





}
